import { styledComponent, Grid, Typography } from '@hermes/web-components'

export const RatingStarsContainer = styledComponent(Grid)(({ theme }) => ({
  gap: '8px',
  alignItems: 'center',
  cursor: 'pointer',
  [theme.breakpoints.up('lg')]: {
    justifyContent: 'center'
  }
}))

export const ReviewsSummary = styledComponent(Typography)(({ theme }) => ({
  fontWeight: 500,
  fontSize: '24px',
  lineHeight: '32px',
  color: theme.palette.text.darkNavy,
  span: {
    fontSize: '13px',
    lineHeight: '20px'
  },
  [theme.breakpoints.down('lg')]: {
    color: theme.palette.text.primary
  }
}))

export const ReviewsCount = styledComponent(Typography)(({ theme }) => ({
  color: theme.palette.text.darkNavy,
  fontSize: '13px',
  lineHeight: '20px',
  [theme.breakpoints.down('lg')]: {
    textDecoration: 'underline'
  }
}))
